import React, { useState } from 'react'
import { Flex, notification, Spin, Typography } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import OtpInput from 'react-otp-input'
import { useTelegram } from '../../context/TelegramContext'
import { useCard } from '../../context/CardContext'
import { palette } from '../../theme/palette'
import axios from '../../utils/axios'

interface VerifyFormProps {
    otpLength?: number
    onSuccess?: () => void
    replaceMode?: boolean
}

const VerifyForm: React.FC<VerifyFormProps> = (props) => {
    const { otpLength = 6, onSuccess, replaceMode = false } = props
    const [api, contextHolder] = notification.useNotification()
    const [otp, setOtp] = useState('')
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const openNotification = () => {
        api.success({
            message: `Muvaffaqiyatli`,
            description: replaceMode
                ? 'Karta muvaffaqiyatli almashtirildi!'
                : 'Sizning kartangiz muvaffaqiyatli ulandi!',
            placement: 'bottom',
            duration: 2.9,
        })
    }

    const { webApp } = useTelegram()
    const { otpConfig, selectedTariff } = useCard()

    const handleSubmit = (data: { code: string }) => {
        setLoading(true)
        // In replace mode the backend ignores `tariff_id` (nothing is charged), and a stale
        // selected-tariff may linger in localStorage — so don't send it.
        const payload = replaceMode
            ? { code: data.code, otp_id: otpConfig.id }
            : { code: data.code, otp_id: otpConfig.id, tariff_id: selectedTariff?.id }
        axios
            .post('/card/activate', payload)
            .then((res) => {})
            .then(() => {
                openNotification()
                if (onSuccess) {
                    onSuccess()
                    return
                }

                if (webApp) {
                    setTimeout(() => {
                        webApp.close()
                    }, 300)
                }
            })
            .catch((err) => {
                setError(err?.body?.message || 'Kodni tasdiqlab bo\'lmadi')
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (otp.length < 6) {
            setError("Iltimos, kodni to'liq kiriting!")
        } else {
            handleSubmit({ code: otp })
        }
    }

    return (
        <form onSubmit={onSubmit}>
            <Typography.Title level={5} className="section-title">
                Kod
            </Typography.Title>
            <Flex vertical align="stretch" gap={'4px'}>
                <Flex vertical>
                    <OtpInput
                        value={otp}
                        onChange={(value) => {
                            setOtp(value)
                            if (error) {
                                setError('')
                            }
                        }}
                        numInputs={otpLength}
                        inputType="number"
                        containerStyle={{ gap: '8px', width: '100%' }}
                        renderInput={(props) => (
                            <input
                                {...props}
                                className={[props.className, 'otp-input', error ? 'error' : '']
                                    .filter(Boolean)
                                    .join(' ')}
                                // react-otp-input hardcodes an inline width of 1em,
                                // which no stylesheet rule can beat.
                                style={{ ...props.style, width: '100%' }}
                                inputMode="numeric"
                                autoComplete="one-time-code"
                                disabled={loading}
                            />
                        )}
                    />
                    <span
                        style={{
                            visibility: error ? 'visible' : 'hidden',
                            opacity: error ? 1 : 0,
                        }}
                        className={`errorMsg`}
                        id="standard-weight-helper-text-login"
                    >
                        {error}
                    </span>
                </Flex>
            </Flex>

            <button
                style={{ 
                    marginTop: 12,
                    opacity: loading ? 0.7 : 1,
                    cursor: loading ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                }}
                className="submit-btn"
                type="submit"
                disabled={loading}
            >
                {loading && (
                    <Spin
                        size="small"
                        indicator={<LoadingOutlined spin style={{ fontSize: 16, color: palette.onAccent }} />}
                    />
                )}
                Yuborish
            </button>
            {contextHolder}
        </form>
    )
}

export default VerifyForm
